import {
  Component,
  ElementRef,
  Inject,
  PLATFORM_ID,
  SecurityContext,
  TransferState,
  ViewChild,
} from '@angular/core';
import { ToastrService } from 'ngx-toastr';

import { CartService } from '@/app/shared/services/cart.service';
import { CommonService } from '@/app/shared/services/common.service';
import { ConfigurationV2Service } from '@/app/shared/services/configuration-v2.service';
import { OrderTemplateService } from '@/app/shared/services/order-template.service';
import { normalizeOrderTemplateError } from '@/app/shared/utils/order-template-error';

import { Breadcrumb } from '@/app/shared/interface/breadcrumb';
import {
  AddUserOrderModel,
  AddUserOrderModelV2,
  Cart,
  CartItem,
  FreeShipResponseModel,
  Gift,
  PaymentMethod,
  TransportMethod,
  UserInfo,
  PriceChangedItem,
  CheckStatusShippingResponseModel,
  DeliveryTimeResponseModel,
  potentialVoucher
} from '@/app/shared/interface/cart.interface';
// import $ from 'jquery';
import { OrderService } from '@/app/shared/services/order.service';
import { Subscription } from 'rxjs';
import { Router, NavigationEnd } from '@angular/router';
import { AddressService } from '@/app/shared/services/address.service';
import {
  DeliveryAddress,
  DeliveryAddressModel,
  StatusAddress,
  User,
  UserTier, UserWallet,
} from '@/app/shared/interface/user.interface';
import { AccountService } from '@/app/shared/services/account.service';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { VoucherService } from '@/app/shared/services/voucher.service';
import { TrackingService } from '@/app/shared/services/tracking.service';
import { ProductConditionDto, Voucher } from '@/app/shared/interface/voucher.interface';
import { SsrCookieService } from 'ngx-cookie-service-ssr';
import { EventEmitter, Input, Output } from '@angular/core';
import { AuthService } from '@/app/shared/services/auth.service';
import { AddressModalComponent } from '@/app/shared/widgets/address-modal/address-modal.component';
import { jwtDecode } from 'jwt-decode';
import { ExchangeGiftModalComponent } from '@/app/shared/widgets/modal/exchange-gift-modal/exchange-gift-modal.component';
import { Product, ProductModel } from '@/app/shared/interface/product.interface';
import { GiftService } from '@/app/shared/services/gift.service';
import { TempCoinSource } from '@/app/shared/interface/order.interface';
import { DomSanitizer } from '@angular/platform-browser';
import { Addressv2ModalComponent } from '@/app/shared/widgets/addressv2-modal/addressv2-modal.component';
import { GiftExchangeConfig } from "@/app/shared/interface/gift.interface";
import {
  ExchangePointGiftModalComponent
} from "@/app/shared/widgets/modal/exchange-point-gift-modal/exchange-point-gift-modal.component";
import { ProvinceV2 } from '@/app/shared/interface/province.interface';
import { WarningPriceChanceModalComponent } from '@/app/shared/widgets/modal/warning-price-chance-modal/warning-price-chance-modal.component';
import { VoucherModalComponent } from '@/app/shared/widgets/modal/voucher-modal/voucher-modal.component';
import { VoucherDetailModalComponent } from '@/app/shared/widgets/modal/voucher-modal/voucher-detail-modal/voucher-detail-modal.component';
import { AnnounceModalComponent } from '@/app/shared/widgets/modal/announce-popup/announce-popup.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CartHistoryModalComponent } from '@/app/shared/widgets/modal/cart-history-modal/cart-history-modal.component';
import { useSafeTimeout } from '@/app/shared/ssr-util';
import { VoucherIneligibleModalComponent } from '@/app/shared/widgets/modal/voucher-ineligible-modal/voucher-ineligible-modal.component';
import { CheckoutEligibilityResponse } from '@/app/shared/interface/checkout-v2.interface';

declare var $: any;

@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.scss'],
})
export class CartComponent {
  @ViewChild('confirmDeleteModal', { static: false }) confirmDeleteModal: any;
  @ViewChild('confirmAddressModal', { static: false }) confirmAddressModal: any;
  @ViewChild('announceModal', { static: false }) announceModal: AnnounceModalComponent;
  @ViewChild('voucherModal', { static: false }) voucherModal: VoucherModalComponent;
  @ViewChild('addressModal') AddressModal: AddressModalComponent;
  @ViewChild('addressV2Modal') AddressV2Modal: Addressv2ModalComponent;
  @ViewChild('exchangeGiftModal') exchangeGiftModal: ExchangeGiftModalComponent;
  @ViewChild('exchangePointGiftModal') exchangePointGiftModal: ExchangePointGiftModalComponent;
  @ViewChild('voucherCode', { static: false }) voucherCode: ElementRef;
  @ViewChild('priceModal') modal!: WarningPriceChanceModalComponent;
  @ViewChild('priceChangedModal') priceChangedModal!: WarningPriceChanceModalComponent;
  @ViewChild("detailModal", { static: false }) detailModal: VoucherDetailModalComponent;
  @ViewChild('cartHistoryModal', { static: false }) cartHistoryModal: CartHistoryModalComponent;
  @ViewChild('voucherIneligibleModal', { static: false }) voucherIneligibleModal: VoucherIneligibleModalComponent;


  @Input() selectedVoucherCode: string[] = [];

  @Output() productLabel: EventEmitter<any> = new EventEmitter<any>();

  cart: Cart = new Cart();
  cartTotal: number = 0;
  selected: number = 0;
  selectedItems: CartItem[] = [];
  selectedItem: CartItem;
  totalQuantity: number = 0;
  isAllCartItemsSelected: boolean = false;
  isAllGiftItemsSelected: boolean = false;
  Math = Math;

  isDeletingSelectedItems: boolean = false;
  usingVoucher: boolean = true;
  vouchers: Voucher[] = [];
  selectedVoucher: Voucher;
  isAutoApplyVoucher: boolean = false;
  debounceAutoApplyVoucher: boolean = true;
  modalVoucherOpen: boolean = false;

  addresses: DeliveryAddress[] = [];
  defaultAddress: DeliveryAddress;
  selectedAddressId: string = '';
  isAccountActivated: boolean = false;
  selectedUserInfoAddress: UserInfo = new UserInfo();
  isAgreeToTerms: boolean = true;
  isExportInvoice: boolean = true;
  isStockOutWithoutPrice: boolean = false;
  isShipmentInOrderEnabled: boolean = false;
  isSaveOrderTemplate: boolean = false;
  orderTemplateName: string = 'Đơn hàng thường xuyên mới';

  productVoucherMap: Record<string, Voucher[]> = {};
  uniqueVouchers: Voucher[] = [];
  applicableVoucherCodes: Set<string> = new Set();
  maxVoucherDisplay = 5;
  user: User;
  userTier: number = 1;

  shippingOptions: DeliveryTimeResponseModel[] = [];
  selectedShippingOption: DeliveryTimeResponseModel | null = null;
  originalPaymentTerms: PaymentMethod[] = [];

  public breadcrumb: Breadcrumb = {
    title: 'Giỏ Hàng',
    items: [{ label: 'Giỏ Hàng', active: true }],
  };

  showMoreArress: boolean = false;
  private routerEvent: Subscription;

  isBrowser: boolean = false;

  transportMethods: TransportMethod[] = [];

  selectedTransportMethod: TransportMethod | null;
  selectedPaymentMethod: PaymentMethod | null = null;
  selectedAddress: DeliveryAddress;

  isSelectedTransportMethod = true;
  isSelectedPaymentMethod = true;

  addressEdit: any;

  // giftInfo: any;
  // giftList: Product[] = [];
  cartItemsMap: Map<string, any> = new Map();

  skeletonLoader: boolean = false;
  public skeletonItems = Array.from({ length: 3 }, (_, index) => index);
  // userPointWallet: UserWallet | null = null;
  // userWallet: UserWallet | null = null
  // pointGiftList: any[] = [];
  // pointGiftInfo: any;
  freeShipMessage: string;
  shipValue: number | undefined;

  progressData: any[] = [];
  currentValue: number = 0;
  additionalCoins: number = 0;
  additionalRankingCoins?: {
    value: number;
    label: string;
    remainingToNext: number;
    nextLabel: string;
  }[] = [];
  additionalTempCoins?: {
    reference: string;
    tempCoinSource: TempCoinSource;
    value: number;
    label: string;
  }[] = [];
  suggestedVouchers?: {
    remainingAmount: number,
    remainingSku: number,
    remainingLabelQuantity: number,   // ← MỚI THÊM
    textTemplate: string,
    voucherCode: string
  }[] = [];
  isExceededMinimumMilestone: boolean = false;
  // usingWalletCoin: boolean = false;
  isUpdating: boolean = false;

  /** Đang gọi check-eligibility hoặc submit-order v2 — disable nút đặt đơn */
  isProcessingOrder: boolean = false;

  // usingCoinAmount: number;

  cartSubscription: Subscription;
  popupClosedSubscription: Subscription;

  exchangedGifts: Gift[] = [];

  deliveryAddress: any = {};

  billingAddress: any = {};

  isLoadingAutoApply: boolean = false;

  invoiceAddressHasReviewed: boolean = false;

  firstTimeLoadCart: boolean = true;
  priceChangedItems: PriceChangedItem[] = [];
  showPriceChangeDetail = false;
  isPriceChanged = false;

  isAuthenticated: boolean = false;

  applyVoucherSubscription: Subscription;
  confirmDeleteMessage: string = '';
  voucherMap: Record<string, potentialVoucher[]> = {}

  SPECIAL_TRANSPORTMETHOD = {
    OTHER: 'Other',
  }

  PAYMENT_METHOD = {
    COD: 'cod',
    TRANSFER: 'bank',
  }

  dumpDataPayment: PaymentMethod[] = [
    {
        code: "cod",
        name: "Thanh toán khi nhận hàng (COD)",
        icon: 'assets/svg/payment/cod.svg',
        iconActive: 'assets/svg/payment/cod_active.svg',
        iconDisabled: 'assets/svg/payment/cod_disabled.svg',
        description: 'Áp dụng cho hình thức vận chuyển này',
        disable: false
    },
    {
        code: "bank",
        name: "Chuyển khoản ngân hàng",
        icon: 'assets/svg/payment/transfer.svg',
        iconActive: 'assets/svg/payment/transfer_active.svg',
        iconDisabled: 'assets/svg/payment/transfer_disabled.svg',
        description: 'Áp dụng cho hình thức vận chuyển này',
        disable: false
    }
  ]

  private safeTimeout = useSafeTimeout();

  constructor(
    private cartService: CartService,
    private commonService: CommonService,
    private toastService: ToastrService,
    private orderService: OrderService,
    private addressService: AddressService,
    private router: Router,
    private accountService: AccountService,
    private voucherService: VoucherService,
    private giftService: GiftService,
    @Inject(PLATFORM_ID) private platformId: Object,
    @Inject(DOCUMENT) private document: Document,
    private transferState: TransferState,
    private authService: AuthService,
    private domSanitizer: DomSanitizer,
    // private walletService: WalletService,
    private cookieService: SsrCookieService,
    private sanitizer: DomSanitizer,
    private modalService: NgbModal,
    private configService: ConfigurationV2Service,
    private tracking: TrackingService,
    private orderTemplateService: OrderTemplateService
  ) {
    this.isAccountActivated = this.authService.isAccountActivated();
    this.isAuthenticated = this.authService.isAuthenticated();
    this.userTier = Number(this.authService.getUserTier());
  }

  ngOnInit() {
    if (this.isAuthenticated) {
      this.configService.getShipmentInOrderFeatureConfig().subscribe({
        next: (res) => {
          this.isShipmentInOrderEnabled = res?.data?.enabled ?? false;
          if (this.isShipmentInOrderEnabled) {
            this.isExportInvoice = true;
          }
        },
        error: (err) => {
          console.log("Update value for isShipmentInOrderEnabled failed: ", err);
        }
      });
      this.getCart();
      this.getChangedCartItemsProducts();
      // this.getGiftList();

      this.getVouchers(); //stop calling it here since we will call it everytime the modal open

      // this.getUserWallet();

      if (isPlatformBrowser(this.platformId)) {
        this.isBrowser = true;
      }

      // this.walletService.userPointWallet$.subscribe({
      //   next: (wallet: UserWallet | null) => {
      //     if (wallet) {
      //       this.userPointWallet = wallet;
      //     }
      //   },
      //   error: (error: any) => {
      //     console.log(error);
      //   },
      // });

      this.getAddresses();
      this.checkInvoiceAddressConfirmed();

      this.popupClosedSubscription = this.commonService.popupClosed.subscribe(() => {
        this.maybeShowTransportAnnouncement();
      });

      this.accountService.getUser().subscribe({
        next: (res: User) => {
          if (res) {
            // this.getGiftInfo();
            // this.giftService.getTotalGiftPoint().subscribe({
            //   next: (giftPoint: any) => {
            //     res.giftPoint = giftPoint.totalPoint;
            //
            //   },
            //   error: (error: any) => {
            //     console.log(error);
            //   },
            // });

            this.user = res;

            this.billingAddress = {
              businessName: res.businessName,
              fullAddress: [
                res.address?.address,
                res.address?.provinceV2?.name,
                ...(res.address?.provinceV2?.wards?.map(ward => ward.name) ?? [])
              ].filter(Boolean).join(', '),
              phone: res.phone,
              email: res.email
            }

          }
        },
        error: (error: any) => {
          console.log(error);
        },
      });
    }
  }

  // getUserWallet() {
  //   let body = {
  //     userName: this.transferState.get(USERNAME, ''),
  //     walletType: WalletType.Coin
  //   }
  //   this.walletService.getUserWallet(body).subscribe({
  //     next: (res: any) => {
  //       if (res) {
  //         this.userWallet = res;
  //       }
  //     },
  //     error: (error) => {
  //       console.log(error);
  //     }
  //   });
  // }

  // loadPointGiftConfig() {
  //   this.giftService.getGiftsFromConfig().subscribe((res: GiftExchangeConfig[]) => {
  //     this.pointGiftInfo = {
  //       giftDescriptionMini: 'Đổi điểm nhận quà theo chương trình khuyến mãi',
  //       totalPoints: this.userPointWallet?.balance
  //     };

  //     this.pointGiftList = res.map(item => ({
  //       name: item.rewardName,
  //       imageUrls: item.imageUrls,
  //       giftExchangeInfo: {
  //         cost: item.requiredPoints
  //       },
  //       description: item.rewardDescription,
  //       cartItem: {
  //         sku: item.rewardItems[0].sku,
  //         quantity: item.rewardItems[0].quantity
  //       }
  //     }));
  //     if (this.cart?.giftExchange) {
  //       this.pointGiftList = this.pointGiftList.map(gift => ({
  //         ...gift,
  //         applied: this.cart.giftExchange.some(
  //           (g: any) => g.sku === gift.cartItem.sku
  //         ),
  //       }));
  //     }
  //   });
  // }

  getCart() {
    this.skeletonLoader = true;
    this.cartSubscription = this.commonService.getCart.subscribe({
      next: (res: any) => {
        if (res) {
          res.items.map((x: any) => {
            x.progressLabel = this.commonService.getProgressLabel(x);
          });
          this.cart = structuredClone(res);
          const items: CartItem[] = res.items.map((item: any) => {
            item.SKU = item.SKU ?? item.sku;
            item.originalQuantity = item.quantity;
            return item;
          });

          this.totalQuantity = res.items.filter((x: any) => x.isSelected).reduce((current: any, next: any) => {
            return current + next.quantity;
          }, 0);

          this.totalQuantity += res.giftItems.reduce((current: any, next: any) => {
            return current + next.exchangedQuantity;
          }, 0);

          const productIds = [...new Set(items.map((item: any) => item.productID))];

          const newCartItems: CartItem[] = [];
          for (let id of productIds) {
            let cartItems = items.filter((i: any) => i.productID === id);
            if (cartItems && cartItems.length > 0) {
              const cartItem: CartItem = structuredClone(cartItems[cartItems.length - 1]);
              cartItem.originalQuantity = cartItem.quantity;
              cartItem.totalPriceSavingAmount = cartItems.reduce((a: number, b: CartItem) => a + (b.totalPriceSavingAmount || 0), 0);
              cartItem.variantItems = cartItems;
              cartItem.totalVariantPrice = cartItem.variantItems.reduce((a: number, b: CartItem) => a + ((b.price * b.quantity) || 0), 0);
              cartItem.currentTier = cartItem.tieredPrices?.find((x: any) => x.pricingTableId == cartItem.appliedPricingTableId);
              cartItem.potentialVouchers = this.voucherMap[cartItem.SKU] || []
              newCartItems.push(cartItem);
            }
          }

          this.cart.items = newCartItems;

          for (let gift of this.cart.giftItems) {
            const foundInCart = this.cart.giftItems.find((item: any) => item.giftId === gift.giftId);
            gift.quantity = foundInCart ? (foundInCart.exchangedQuantity || 0) : 0;
            gift.isSelected = true;
          }

          // Gifts
          // const giftList = res.giftItems || [];
          // const giftIds = [...new Set(giftList.map((gift: Gift) => gift.giftId))];
          // const newGiftItems: Gift[] = [];
          // for (let id of giftIds) {
          //   let giftItems = giftList.filter((i: Gift) => i.giftId === id);
          //   if (giftItems && giftItems.length > 0) {
          //     const giftItem: Gift = structuredClone(giftItems[0]);
          //     giftItem.totalGiftsExchanged = giftItems.reduce((a: number, b: Gift) => a + (b.exchangedQuantity ?? 0), 0);

          //     newGiftItems.push(giftItem);
          //   }
          // }

          // this.cart.giftItems = newGiftItems;

          // this.loadApplicableVouchers();
          // this.getRelevantVouchersForProductFromCart();
          // this.loadPointGiftConfig();
          this.getFreeShip(this.selectedAddress)
          this.getVoucherOnItems();
          // this.checkStatusShipping(this.selectedAddress);

          this.cartItemsMap = this.createCartItemsMap(this.cart.items);
          this.tracking.cartViewed(this.cart);
          this.skeletonLoader = false;

          if (this.cart.items.length && this.cart.items.every(x => x.isSelected)) {
            this.isAllCartItemsSelected = true;
          }
          else {
            this.isAllCartItemsSelected = false;
          }

          this.selectedItems = this.cart.items.filter(x => x.isSelected);
          this.selected = this.cart.items.filter((item) => item.isSelected).length;
          this.isAutoApplyVoucher = this.cart.isAutoApplyVoucher || false;
          // this.usingCoinAmount = this.cart.appliedCoin || 0;
          // this.usingWalletCoin = (this.cart.appliedCoin || 0) > 0;
          this.suggestedVouchers = this.cart.suggestedVouchers;
          if (this.cart.items.length) this.tracking.voucherSuggestionsShown(this.suggestedVouchers);

          if (this.cart.items.length == 0) {
            this.progressData = [];
            this.currentValue = 0;
            this.additionalCoins = 0;
            this.additionalRankingCoins = [];
            return;
          }

          // setTimeout(() => {
          //   if (this.cart.coinMilestoneValues?.milestones.length > 0) {
          //     this.progressData = this.cart.coinMilestoneValues?.milestones || [];
          //     this.isExceededMinimumMilestone = this.cart.coinMilestoneValues.currentProgress >= this.cart.coinMilestoneValues.milestones[0].estimatedValue;
          //     if (this.isExceededMinimumMilestone) {
          //       this.additionalCoins = this.cart.estimatedReceiveTempCoin - this.currentValue;
          //       this.additionalRankingCoins = this.cart.estimatedTempCoinMilestones;
          //       this.additionalTempCoins = this.cart.estimatedTempCoinList;
          //       this.currentValue = this.cart.estimatedReceiveTempCoin;
          //       // setTimeout(() => {
          //       //   this.commonService.animateProgress(this.additionalCoins, () => {
          //       //     this.commonService.setOdometer(this.currentValue);
          //       //   }, this.firstTimeLoadCart);
          //       //   this.firstTimeLoadCart = false;
          //       // }, 100);
          //     }
          //     else {
          //       this.additionalCoins = -this.currentValue;
          //       this.currentValue = 0;
          //       // setTimeout(() => {
          //       //   this.commonService.animateProgress(this.additionalCoins);
          //       //   this.commonService.setOdometer(this.currentValue);
          //       // }, 100);
          //     }
          //   }
          //   else {
          //     this.currentValue = 0;
          //     // this.commonService.animateProgress(this.additionalCoins);
          //     // this.commonService.setOdometer(this.currentValue);
          //   }
          // }, 1);
        }
      },
    });
    this.routerEvent = this.router.events.subscribe({
      next: (val: any) => {
        if (val instanceof NavigationEnd) {
          if (this.router.url.includes('/cart')) {
            if (isPlatformBrowser(this.platformId)) {
              window.scrollTo({ top: 0, behavior: 'smooth' });
            }
          }
        }
      },
    });
  }

  getAdditionalTempCoins(): number {
    return (this.additionalTempCoins || [])
      .reduce((sum: number, item: any) => sum + (item.value || 0), 0);
  }

  // getGiftInfo() {
  //   this.giftService.getGiftInfo.subscribe({
  //     next: (res: any) => {
  //       if (res) {
  //         this.giftInfo = res;
  //       }
  //     }
  //   });
  // }

  // getGiftList() {
  //   let body = {
  //     limit: 100,
  //     offset: 0,
  //   }
  //   this.giftService.getGiftList(JSON.stringify(body)).subscribe({
  //     next: (res: ProductModel) => {
  //       if (res && res.products.length > 0) {
  //         this.giftList = res.products;
  //       }
  //     },
  //     error: (error: any) => {
  //       console.log(error);
  //     },
  //   });
  // }

  getCartItem(product: any) {
    let cartItem = {
      imgUrl: product.imageUrls[0],
      name: product.name,
      price: product.basePrice,
      basePrice: product.basePrice,
      productID: product.productID,
      quantity: 0,
      labels: product.labels,
      SKU: product.SKU,
      slug: product.slug,
    };

    const existingCartItem = this.cartItemsMap.get(product.productID);
    if (existingCartItem) {
      cartItem = existingCartItem;
    }

    return cartItem;
  }

  createCartItemsMap(cartItems: any[]): Map<string, any> {
    const cartItemsMap = new Map<string, any>();
    for (let item of cartItems) {
      this.getNextWholesalePrice(item);
      item.tieredPrice = item.tieredPrices.find((tier: any) => tier.pricingTableId == item.appliedPricingTableId);
      cartItemsMap.set(item.productID, item);
    }
    return cartItemsMap;
  }

  getAddresses() {
    if (this.isBrowser) {
      // const token = this.cookieService.get('token');
      const token = this.cookieService.get('token');
      if (!token) {
        return;
      }
      // if (!localStorage.getItem("token")?.length) {
      //   return;
      // }
    }

    this.addressService.getUserAddress().subscribe({
      next: (res: DeliveryAddressModel) => {
        const all = res?.deliveryAddress ?? [];

        const filtered = all.filter(
          (a): a is DeliveryAddress & { provinceV2: ProvinceV2 } => !!a?.provinceV2
        );

        if (filtered.length === 0) {
          this.addresses = [];
          this.defaultAddress = undefined as any;
          return;
        }

        this.addresses = filtered.sort((a, b) => a.status - b.status);

        this.defaultAddress =
          this.addresses.find(a => a.status === StatusAddress.Default) ??
          this.addresses[0];

        const idx = this.addresses.findIndex(a => a.id === this.defaultAddress.id);
        this.selectAddress(Math.max(0, idx));
      },
      error: (error: any) => {
        console.log(error);
      },
    });

  }

  getVouchers() {
    this.voucherService.availableVouchers$.subscribe({
      next: (res: Voucher[]) => {
        if (!res || !Array.isArray(res)) {
          return;
        }
        this.vouchers = res;
      },
      error: (error: any) => {
        console.log(error);
      },
      complete: () => {
      }
    });
  }

  showMore() {
    this.showMoreArress = !this.showMoreArress;
  }

  selectAddress(index: number) {
    if (!this.cart.userInfo) {
      this.cart.userInfo = new UserInfo();
    }
    this.selectedAddress = this.addresses[index];
    this.deliveryAddress = {
      receiverName: this.selectedAddress.receiverName,
      fullAddress: [
        this.selectedAddress.address,
        this.selectedAddress.provinceV2?.name,
        ...(this.selectedAddress.provinceV2?.wards?.map(ward => ward.name) ?? [])
      ].filter(Boolean).join(', '),
      phone: this.selectedAddress.receiverPhone
    }

    this.selectedAddressId = this.selectedAddress.id;

    this.selectedUserInfoAddress.id = this.selectedAddressId;

    if (this.selectedAddress.provinceV2) {
      const wardName = this.selectedAddress.provinceV2.wards?.[0]?.name ?? '';
      this.selectedUserInfoAddress.address =
        `${this.selectedAddress.address}, ${this.selectedAddress.provinceV2.name}` +
        (wardName ? `, ${wardName}` : '');
    } else if (this.selectedAddress.province) {
      const districtName = this.selectedAddress.province.districts?.[0]?.name ?? '';
      const wardName = this.selectedAddress.province.districts?.[0]?.wards?.[0]?.name ?? '';
      this.selectedUserInfoAddress.address =
        `${this.selectedAddress.address}, ${this.selectedAddress.province.name}` +
        (districtName ? `, ${districtName}` : '') +
        (wardName ? `, ${wardName}` : '');
    }

    this.selectedUserInfoAddress.phone = this.selectedAddress.receiverPhone;
    this.selectedUserInfoAddress.userName = this.selectedAddress.receiverName;
    this.cart.userInfo = this.selectedUserInfoAddress;

    this.getTransportMethods(this.selectedAddressId);
    this.getFreeShip(this.selectedAddress);
    // this.checkStatusShipping(this.selectedAddress);
  }

  delete(product: any) {
    let body = {
      productId: product.productID,
      quantity: 0,
    };
    this.cartService.updateCart(JSON.stringify(body)).subscribe({
      next: (res: any) => {
        product.quantity = body.quantity;
        this.commonService.setCart(res);
        this.selectedItems = this.selectedItems.filter(x => x.productID != product.productID);
        this.loadApplicableVouchers();
        this.toastService.success('Đã cập nhật giỏ hàng!', '', {
          positionClass: 'toast-top-right',
        });

      },
      error: (error) => {
        product.quantity = 0;
        console.log(error);
        this.toastService.warning('Lỗi cập nhật giỏ hàng!', '', {
          positionClass: 'toast-top-right',
        });
      },
    });
  }

  checkAll() {
    this.isAllCartItemsSelected = !this.isAllCartItemsSelected;
    $('.chk').prop('checked', $('.chk-all').prop('checked'));
    this.selected = $('.chk:checked').length;

    if (this.isAllCartItemsSelected) {
      this.cart.items.forEach((item) => {
        item.isSelected = true;
      });
      this.selectedItems = [...this.cart.items];
    } else {
      this.cart.items.forEach((item) => {
        item.isSelected = false;
      });
      this.selectedItems = [];
    }

    const updatedItems: CartItem[] = this.cart.items.map((item) => ({
      ...item,
      quantity: item.quantity,
      isSelected: item.isSelected,
    }));

    this.updateMany(updatedItems);
  }

  selectCheckbox(cartItem: CartItem) {
    $('.chk-all').prop('checked', $('.chk').length == $('.chk:checked').length);
    this.selected = $('.chk:checked').length;
    if (
      !this.selectedItems.some((item) => item.productID == cartItem.productID)
    ) {
      this.selectedItems.push(cartItem);
    } else {
      this.selectedItems = this.selectedItems.filter(
        (item) => item.productID != cartItem.productID
      );
    }

    this.commonService.selectedCartItem = cartItem;

    let body = {
      productId: cartItem.productID,
      quantity: cartItem.quantity,
      isSelected: !cartItem.isSelected,
    };
    this.cartService.updateCart(JSON.stringify(body)).subscribe(
      (res: any) => {
        this.cart = res;
        this.commonService.setCart(this.cart);
        this.loadApplicableVouchers();
      },
      (error) => {
        console.log(error);
      }
    );
  }

  deleteSelectedItems() {
    if (this.selectedItems.length == 0) {
      this.toastService.error('Xin vui lòng chọn sản phẩm!', '', {
        positionClass: 'toast-top-right',
      });
      return;
    }
    this.isDeletingSelectedItems = true;
    if (this.selectedItems.length == 1) {
      this.confirmDeleteMessage = `Bạn có chắc muốn loại bỏ sản phẩm <span class="fw-semibold">[${this.sanitizer.sanitize(1, this.selectedItems[0].name)}]</span> khỏi giỏ hàng?`
    } else {
      this.confirmDeleteMessage = `Bạn có chắc muốn loại bỏ <span class="fw-semibold">${this.selectedItems.length == this.cart.items.length ? 'Tất Cả' : this.selectedItems.length}</span> sản phẩm khỏi giỏ hàng?`
    }
    this.confirmDeleteModal.openModal();
  }

  confirmDelete(value?: boolean) {
    if (value) {
      if (this.isDeletingSelectedItems) {
        if (!this.commonService.selectedCartItem) {
          this.commonService.selectedCartItem = new CartItem();
        }
        this.commonService.selectedCartItem.coinIconLevel = Math.max(...this.selectedItems.map(x => x.coinIconLevel));
        this.deleteMany(this.selectedItems);
      } else {
        this.commonService.selectedCartItem = this.selectedItem;
        this.delete(this.selectedItem);
      }
    }
    // else {
    //   if (this.selectedItems.length > 0 && !$('#' + this.selectedItem.productID).prop('checked')) {
    //     this.selectedItems = this.selectedItems.filter(item => item.productID != this.selectedItem.productID);
    //   }
    // }
    this.confirmDeleteMessage = '';
    this.isDeletingSelectedItems = false;
  }

  openModal(cartItem: CartItem) {
    this.selectedItem = cartItem;
    if (
      !this.selectedItems.some((item) => item.productID == cartItem.productID)
    ) {
      this.selectedItems.push(cartItem);
    }
    this.confirmDeleteMessage = `Bạn có chắc muốn loại bỏ sản phẩm <span class="fw-semibold">[${this.sanitizer.sanitize(SecurityContext.HTML, cartItem.name)}]</span> khỏi giỏ hàng?`
    this.confirmDeleteModal.openModal();
  }

  checkout() {
    // Dont know why i cant use jquery here
    // $('#agree').prop('checked')

    if (this.cart.giftItems.length == 0 && this.cart.items.length == 0) {
      this.tracking.errorShown('validation_error', 'cart_empty');
      this.toastService.warning('Giỏ quà tặng và giỏ hàng của bạn đang trống!', '', {
        positionClass: 'toast-top-right',
      });
      return;
    }

    if (!this.isAgreeToTerms) {
      this.tracking.errorShown('validation_error', 'terms_not_agreed');
      this.toastService.warning('Bạn chưa đồng ý với điều khoản sử dụng và chính sách bảo mật!', '', {
        positionClass: 'toast-top-right',
      });
      return;
    }
    if (!this.selectedAddress) {
      this.tracking.errorShown('validation_error', 'missing_address');
      this.toastService.warning('Chưa có địa chỉ giao hàng theo cấu trúc mới, vui lòng thêm mới!', '', {
        positionClass: 'toast-top-right',
      });
      return;
    }
    if (!this.selectedTransportMethod) {
      this.isSelectedTransportMethod = false;
      this.tracking.errorShown('validation_error', 'missing_shipping');
      this.toastService.warning('Vui lòng chọn hình thức vận chuyển!', '', {
        positionClass: 'toast-top-right',
      });
      return;
    } else {
      this.isSelectedTransportMethod = true;
    }

    // if (this.shippingOptions.length > 0 && !this.selectedShippingOption) {
    //   this.toastService.warning('Vui lòng chọn thời gian giao hàng!', '', {
    //     positionClass: 'toast-top-right',
    //   });
    //   return;
    // }

    if (!this.selectedPaymentMethod) {
      this.isSelectedPaymentMethod = false;
      this.tracking.errorShown('validation_error', 'missing_payment');
      this.toastService.warning('Vui lòng chọn hình thức thanh toán!', '', {
        positionClass: 'toast-top-right',
      });
      return;
    } else {
      this.isSelectedPaymentMethod = true;
    }

    let noteElement = this.document.getElementById('note') as HTMLTextAreaElement;
    let noteValue = noteElement?.value?.trim() || '';

    if (this.selectedShippingOption?.description) {

      const shippingNote = `---${this.selectedShippingOption.description}`;

      if (!noteValue.includes(this.selectedShippingOption.description)) {
        noteValue += shippingNote;
      }
    }
    this.cart.note = noteValue;

    if (!this.selectedUserInfoAddress.address) {
      this.tracking.errorShown('validation_error', 'missing_address_info');
      this.toastService.warning('Chưa có thông tin địa chỉ giao hàng vui lòng thêm thông tin!', '', {
        positionClass: 'toast-top-right',
      });
      return;
    }

    this.cart.userInfo = this.selectedUserInfoAddress;
    // Giỏ hàng là MỘT màn hình (địa chỉ, vận chuyển, thanh toán nằm chung), nên không có các bước riêng để ghi.
    // Chỉ ghi một lần khi khách bấm đặt hàng và qua mọi kiểm tra (chưa qua thì đã có error_shown ở trên).
    this.tracking.checkoutStep('review');

    if (!this.invoiceAddressHasReviewed) {
      this.confirmAddressModal.openModal();
    }
    else {
      this.cart.needReviewAddress = false;
      this.confirmCheckout(true);
    }
  }

  confirmCheckout(value?: boolean) {
    if (!value) return;
    if (!this.selectedTransportMethod) return;

    this.cart.transportMethod = this.selectedTransportMethod.code;
    this.cart.shipValue = this.shipValue;

    if (this.selectedTransportMethod?.paymentMethod && this.selectedTransportMethod?.paymentMethod.length > 0) {
      this.cart.paymentMethod = this.selectedPaymentMethod!.code;
    }

    const token = this.cookieService.get('token');
    const jwt = jwtDecode(token) as any;
    this.cart.userInfo.status = Number(UserTier[jwt.Status]);

    let cart = structuredClone(this.cart);
    let cartItems: CartItem[] = [];
    for (let item of cart.items) {
      if (item.isSelected) {
        cartItems = cartItems.concat(item.variantItems || []);
      }
    }
    cart.items = cartItems;

    const cartBody: AddUserOrderModel = {
      cart: cart,
      transportV2: {
        transportId: this.selectedTransportMethod.transportId,
        code: this.selectedTransportMethod.code,
        name: this.selectedTransportMethod.name,
      },
      exportInvoice: this.isExportInvoice,
      stockOutWithoutPrice: this.isStockOutWithoutPrice,
    };

    this.isProcessingOrder = true;

    // Bước 1: Xem trước voucher eligibility trước khi đặt đơn
    this.orderService.checkVoucherEligibility().subscribe({
      next: (review: any) => {
        if (!review.hasIneligibleAppliedVouchers) {
          // Không có voucher không hợp lệ → submit trực tiếp với RejectOrderSubmission
          this.executeOrderSubmission(cartBody, 'RejectOrderSubmission');
        } else {
          // Có voucher không hợp lệ → mở modal yêu cầu xác nhận
          this.isProcessingOrder = false;

          this.voucherIneligibleModal
            .openModal(review.ineligibleAppliedVouchers, review.cartAfterRemovingIneligibleVouchers, this.cart.appliedVouchers || [])
            .then((confirmed: boolean) => {
              if (confirmed) {
                this.isProcessingOrder = true;
                this.executeOrderSubmission(cartBody, 'RemoveAndSubmitOrder');
              }
            });
        }
      },
      error: (err) => {
        this.isProcessingOrder = false;
        const msg = err?.error?.message || 'Có lỗi xảy ra khi kiểm tra voucher. Vui lòng thử lại.';
        this.toastService.warning(msg, '', { positionClass: 'toast-top-right' });
      }
    });
  }

  /**
   * Gửi request tạo đơn v2 (POST /order/v2/checkout/submit-order).
   * Xử lý lỗi HTTP 409 yêu cầu xác nhận bỏ voucher từ BE.
   */
  private executeOrderSubmission(
    cartBody: AddUserOrderModel,
    handling: 'RejectOrderSubmission' | 'RemoveAndSubmitOrder' = 'RejectOrderSubmission'
  ) {
    const v2Body: AddUserOrderModelV2 = {
      ...cartBody,
      ineligibleAppliedVoucherHandling: handling,
    };

    this.orderService.submitOrderV2(v2Body).subscribe({
      next: (res: any) => {
        this.isProcessingOrder = false;
        this.saveOrderTemplateIfRequested(res.orderId);
        if (res.statusCode === 201) {
          this.toastService.warning(res.message, '', { positionClass: 'toast-top-right' });
          this.router.navigate(['/thank-you'], { state: res });
        } else {
          this.toastService.success('Tạo đơn hàng thành công!', '', { positionClass: 'toast-top-right' });
          this.commonService.notificationChange();
          this.router.navigate(['/thank-you'], { state: res });
        }
        this.cartService.getCarts().subscribe({
          next: (res: any) => {
            this.cart = res;
            this.commonService.setCart(this.cart);
          },
        });
        this.accountService.setUserData(this.user);
      },
      error: (error) => {
        this.isProcessingOrder = false;

        const errorCode = error?.error?.errorCode || '';
        const errorMsg = error?.error?.message || '';
        this.tracking.orderFailed(error);

        if (error?.status === 423) {
          this.toastService.warning('Đơn hàng đang được xử lý, vui lòng chờ.', '', {
            positionClass: 'toast-top-right',
          });
          return;
        }

        if (errorCode === 'INELIGIBLE_APPLIED_VOUCHERS_REQUIRE_CONFIRMATION') {
          // BE trả 409 yêu cầu xác nhận bỏ voucher (data chứa review)
          const reviewData = error?.error?.data;
          if (reviewData) {
            this.voucherIneligibleModal
              .openModal(reviewData.ineligibleAppliedVouchers, reviewData.cartAfterRemovingIneligibleVouchers, this.cart.appliedVouchers || [])
              .then((confirmed: boolean) => {
                if (confirmed) {
                  this.isProcessingOrder = true;
                  this.executeOrderSubmission(cartBody, 'RemoveAndSubmitOrder');
                }
              });
          } else {
            this.toastService.warning(errorMsg, '', { positionClass: 'toast-top-right' });
          }
          return;
        }

        if (errorCode === 'PRICING_TABLE_CHANGED') {
          this.priceChangedModal.open();
          return;
        }

        if (['CART_STATE_CHANGED', 'VOUCHER_GLOBAL_QUOTA_INSUFFICIENT', 'VOUCHER_UNITS_ADJUSTED'].includes(errorCode)) {
          this.toastService.warning(errorMsg, '', { positionClass: 'toast-top-right', timeOut: 5000 });
          this.cartService.getCarts().subscribe({
            next: (res: any) => {
              this.cart = res;
              this.commonService.setCart(this.cart);
            }
          });
          return;
        }

        this.toastService.warning(errorMsg, '', { positionClass: 'toast-top-right' });

        if (handling === 'RemoveAndSubmitOrder') {
          this.cartService.getCarts().subscribe({
            next: (res: any) => {
              this.cart = res;
              this.commonService.setCart(this.cart);
            }
          });
        }
      }
    });
  }

  private saveOrderTemplateIfRequested(orderId: string): void {
    if (!this.isSaveOrderTemplate || !orderId) return;

    const templateName = this.orderTemplateName?.trim() || 'Đơn hàng thường xuyên mới';
    this.orderTemplateService.createFromOrder({ orderId, name: templateName }).subscribe({
      next: (templateRes) => {
        if (templateRes?.isSuccess) {
          this.toastService.success('Đã lưu thành đơn hàng thường xuyên!', '', {
            positionClass: 'toast-top-right',
          });
        } else {
          this.toastService.error(normalizeOrderTemplateError(templateRes).message, '', {
            positionClass: 'toast-top-right',
          });
        }
      },
      error: (templateErr) => {
        console.error('Lỗi khi tạo đơn hàng thường xuyên từ đơn hàng:', templateErr);
        this.toastService.error(normalizeOrderTemplateError(templateErr).message, '', {
          positionClass: 'toast-top-right',
        });
      }
    });
  }


  deleteMany(list: CartItem[]) {
    let items: any[] = [];
    for (const cartItem of list) {
      const item = {
        productId: cartItem.productID,
        quantity: 0,
      };
      items.push(item);
    }
    const body = {
      items: items,
    };
    this.cartService.updateCartMany(JSON.stringify(body)).subscribe({
      next: (res: any) => {
        this.cart = res;
        this.commonService.setCart(this.cart);
        this.loadApplicableVouchers();
        this.toastService.success('Đã cập nhật giỏ hàng', '', {
          positionClass: 'toast-top-right',
        });
      },
      error: (error) => {
        console.log(error);
        this.toastService.warning(error.error.message, '', {
          positionClass: 'toast-top-right',
        });
      },
    });
  }

  updateMany(list: CartItem[]) {
    let items: any[] = [];
    for (const cartItem of list) {
      const item = {
        productId: cartItem.productID,
        quantity: cartItem.quantity,
        isSelected: cartItem.isSelected,
      };
      items.push(item);
    }
    const body = {
      items: items,
    };
    this.cartService.updateCartMany(JSON.stringify(body)).subscribe({
      next: (res: any) => {
        this.cart = res;
        this.commonService.setCart(this.cart);
        this.loadApplicableVouchers();
      },
      error: (error) => {
        console.log(error);
      },
    });
  }

  applyVoucher(voucher: string, unitsUsed?: number) {
    if (voucher) {
      const body = {
        voucherCode: voucher,
        unitsUsed: unitsUsed || 1,
      };
      this.cartService.applyVoucher(JSON.stringify(body)).subscribe({
        next: (res: Cart) => {
          if (res) {
            // this.cart = res;
            this.cart = {
              ...res,
              items: res.items.map((item: any) => ({
                ...item,
                SKU: item.SKU ?? item.sku,
              })),
            };
            this.commonService.setCart(this.cart);

            if (this.cart.payloadErrors && this.cart.payloadErrors.length > 0) {
              this.tracking.errorShown('voucher_invalid', voucher);
              this.cart.payloadErrors.forEach((errorMsg: string) => {
                this.toastService.warning(errorMsg, '', {
                  positionClass: 'toast-top-right',
                });
              });
            } else {
              this.tracking.voucherApplied(voucher);
              this.toastService.success('Áp dụng mã thành công', '', {
                positionClass: 'toast-top-right',
              });
            }
            //this.voucherCode.nativeElement.value = '';
            // this.cartService.getCarts().subscribe({
            //   next: (res: any) => {
            //     this.cart = res;

            //   },
            // });
          }
        },
        error: (error: any) => {
          // this.toastService.warning('Mã giảm giá hết hạn hoặc đơn hàng chưa đủ điều kiện !! Vui lòng kiểm tra lại', "", { positionClass: "toast-top-right" });
          this.tracking.errorShown('voucher_invalid', voucher);
          this.toastService.warning(error.error.detail, '', {
            positionClass: 'toast-top-right',
          });
        },
      });
    } else {
      this.toastService.warning('Vui lòng nhập mã giảm giá!', '', {
        positionClass: 'toast-top-right',
      });
    }
  }

  autoApplyVoucher() {
    if (this.debounceAutoApplyVoucher) {
      this.debounceAutoApplyVoucher = false;
      this.isAutoApplyVoucher = !this.isAutoApplyVoucher;
      this.cartService.toggleAutoApplyVoucher().subscribe({
        next: (res: any) => {
          if (res) {

            this.commonService.setCart(res.data);

            this.toastService.success('Đã cập nhật cài đặt tự động áp dụng mã giảm giá', '', {
              positionClass: 'toast-top-right',
            });
          }
        },
        error: (error: any) => {
          this.debounceAutoApplyVoucher = true;
        },
        complete: () => {
          this.debounceAutoApplyVoucher = true;
        }
      });
    }
  }

  TriggerAutoApplyVoucher() {
    if (!this.isLoadingAutoApply) {
      this.isLoadingAutoApply = true;
      this.cartService.triggerAutoApplyVoucher().subscribe({
        next: (res: any) => {
          this.isLoadingAutoApply = false;

          if (res) {
            // this.cart = res.data?.cart || res.data;

            this.toastService?.success( res?.message, 'Thành công', {
              positionClass: 'toast-top-right',
            });

            this.cartService.getCarts().subscribe({
              next: (res: any) => {
                this.cart = res;
                this.commonService.setCart(this.cart);
              },
            });
          } else {
            this.toastService?.warning(
              res?.message || 'Không tìm thấy voucher phù hợp',
              'Thông báo',
            );
          }
        },
        error: (error: any) => {
          this.isLoadingAutoApply = false;
          console.error('Auto apply voucher error:', error);
          this.toastService?.error(
            error?.error?.message || 'Có lỗi xảy ra khi áp dụng voucher tự động',
            'Lỗi'
          );
        }
      });
    }
  }


  deleteVoucher(code?: string) {
    this.cartService.removeVoucherByCode(code).subscribe({
      next: (res: Cart) => {
        if (res) {
          // this.cart = res;
          this.toastService.success('Đã xóa mã giảm giá', '', {
            positionClass: 'toast-top-right',
          });
          this.cartService.getCarts().subscribe({
            next: (res: any) => {
              this.cart = res;
              this.commonService.setCart(this.cart);
            },
          });
        }
      },
      error: (error: any) => {
        this.toastService.warning(
          'Mã giảm giá hết hạn hoặc sai !! Vui lòng nhập lại',
          '',
          { positionClass: 'toast-top-right' }
        );
      },
    });
  }

  // openVoucherModal(code?: string) {
  //   if (code) {
  //     this.selectedVoucherCode = Array.isArray(code) ? code : [code];
  //   } else {
  //     this.selectedVoucherCode = [];
  //   }
  //   this.voucherModal.openModal();
  // }

  openVoucherModal(vouchers?: Voucher[], clickedCode?: string) {
    if (vouchers) {
      const codes = vouchers.map(v => v.code);

      const uniqueCodes = clickedCode
        ? [clickedCode, ...codes.filter(code => code !== clickedCode)]
        : codes;

      this.selectedVoucherCode = uniqueCodes;
    } else {
      this.selectedVoucherCode = [];
    }

    this.voucherModal.openModal();

    this.applyVoucherSubscription =  this.voucherService.applyVoucher.subscribe({
      next: (voucher: Voucher) => {
        if (!voucher.isApplied) {
          this.deleteVoucher(voucher.code);
        }
      }
    });
  }

  onCloseVoucherModal(event: any) {
    this.applyVoucherSubscription?.unsubscribe();
  }

  openVoucherModalByApplicableVoucher(vouchers?: Voucher[]) {
    if (vouchers) {
      const sortedVouchers = vouchers.slice().sort((a, b) => {
        const aApplicable = this.isVoucherApplicable(a.code);
        const bApplicable = this.isVoucherApplicable(b.code);
        return (aApplicable === bApplicable) ? 0 : (aApplicable ? -1 : 1);
      });

      this.selectedVoucherCode = sortedVouchers.map(v => v.code);
    } else {
      this.selectedVoucherCode = [];
    }

    this.voucherModal.openModal();
  }

  async selectVoucher(voucher: any) {
    const matchedVoucher = this.vouchers.find((v: Voucher) => {
      return v.code === voucher.voucherCode;
    });
    if (matchedVoucher) {
      this.selectedVoucher = matchedVoucher;
      if (!this.modalVoucherOpen) {
      this.modalVoucherOpen = true;
      this.safeTimeout(() => {
        this.detailModal.openModal();
      }, 10);
    }
    }
  }

  changeTransportMethod(transportMethod: TransportMethod) {
    // call api to get payment method
    this.selectedTransportMethod = transportMethod;
    this.originalPaymentTerms = [...(transportMethod.paymentMethod || [])];
    // this.resetShippingOption();
    if (this.transportMethods.length == 1 && this.transportMethods[0].code == this.SPECIAL_TRANSPORTMETHOD.OTHER) {

    } else {
      this.selectedPaymentMethod = null;
    }
    this.checkTransportHasPayment();
  }

  queryStringBuilder(slug: string) {
    this.productLabel.emit(slug);
    // set label query string
    this.router.navigate(['/product'], {
      queryParams: {
        label: slug,
      },
      queryParamsHandling: '', // optional
    });
  }

  changePaymentMethod(paymentMethod: PaymentMethod) {
    if (paymentMethod.disable) {
      return;
    }

    this.selectedPaymentMethod = paymentMethod;
  }

  ngOnDestroy() {
    this.routerEvent?.unsubscribe();
    this.cartSubscription?.unsubscribe();
    this.popupClosedSubscription?.unsubscribe();
    this.modalService.dismissAll();
  }

  getTransportMethods(addressID: string) {
    this.cartService.getTranferMethods(addressID).subscribe({
      next: (res: TransportMethod[]) => {
        if (!res?.length) return;
        this.transportMethods = res;
        if (this.transportMethods.length == 1) {
          this.selectedTransportMethod = structuredClone(this.transportMethods[0]);
          const potentialPaymentMethods = this.dumpDataPayment.find(pm => pm.code === this.selectedTransportMethod?.paymentMethod?.[0]?.code);
          if (potentialPaymentMethods) {
            this.selectedPaymentMethod = potentialPaymentMethods;
          }
        } else {
          this.selectedTransportMethod = null;
          this.selectedPaymentMethod = null;
        }
        this.checkTransportHasPayment();
        this.maybeShowTransportAnnouncement();
      },
    });
  }

  private maybeShowTransportAnnouncement() {
    if (this.transportMethods.length <= 1) {
      return;
    }

    if (!this.commonService.getPopupClosed()) {
      return;
    }

    const STORAGE_KEY = 'transport_announce_popup_time';
    const lastOpenTime = localStorage.getItem(STORAGE_KEY);
    const now = Date.now();
    const BREAK_TIME = 10 * 60 * 1000;
    if (!lastOpenTime || now - Number(lastOpenTime) > BREAK_TIME) {
      localStorage.setItem(STORAGE_KEY, now.toString());
      this.modalService.dismissAll();
      this.safeTimeout(() => {
        this.announceModal.openModal();
      }, 500);
    }
  }

  isTetShipping(option: CheckStatusShippingResponseModel | null): boolean {
    return option?.title?.toLowerCase().includes('giao trước tết') ?? false;
  }

  resetAddress() {
    this.addressEdit = undefined;
  }

  addAddressAfterCreate(event: DeliveryAddress) {
    this.getAddresses();
  }

  onEditAddress(address: DeliveryAddress) {
    this.addressEdit = address;
    if (this.addressEdit.provinceV2) {
      this.AddressV2Modal.openModal();
    } else if (this.addressEdit.province) {
      this.AddressModal.openModal();
    }
  }

  addAddress() {
    this.addressEdit = undefined;
    this.AddressV2Modal.openModal();
  }

  getNextWholesalePrice(cartItem: CartItem) {
    if (cartItem.wholesalePrices?.length) {
      for (let i = 0; i < cartItem.wholesalePrices.length; i++) {
        if (cartItem.quantity < cartItem.wholesalePrices[i].minQuantity) {
          cartItem.wholesalePriceInfo = cartItem.wholesalePrices[i];
          break;
        }
      }
    }
  }

  getRelevantVouchersForProductFromCart(): void {
    const items = this.cart?.items ?? [];
    if (!items.length) return;

    const conditions: ProductConditionDto[] = [];
    const selectedSkus = new Set<string>();
    const selectedLabels = new Set<string>();

    for (const item of items) {
      const sku = item.SKU;
      const labels = item.labels ?? [];

      if (sku) {
        conditions.push({ sku });
        if (item.isSelected) selectedSkus.add(sku);
      }

      for (const label of labels) {
        if (label?.slug) {
          conditions.push({ label: label.slug });
          if (item.isSelected) selectedLabels.add(label.slug);
        }
      }
    }

    if (!conditions.length) return;

    this.voucherService.getRelevantVoucherProducts(conditions).subscribe({
      next: (vouchers: Voucher[]) => {
        this.productVoucherMap = {}; // SKU or label => Voucher[]
        this.uniqueVouchers = [];
        const seenVoucherCodes = new Set<string>();

        const addToMap = (key: string, voucher: Voucher) => {
          if (!this.productVoucherMap[key]) {
            this.productVoucherMap[key] = [];
          }
          this.productVoucherMap[key].push(voucher);
        };

        for (const voucher of vouchers) {
          const pqConditions = voucher.voucherCondition?.productQuantityConditions ?? [];
          const labelConditions = voucher.voucherCondition?.applicableLabelQuantity ?? [];
          const labelCondition: string[] = voucher.voucherCondition?.applicableLabels ?? []

          for (const pq of pqConditions) {
            const sku = pq?.sku;
            if (!sku) continue;

            addToMap(sku, voucher);

            if (selectedSkus.has(sku) && !seenVoucherCodes.has(voucher.code)) {
              seenVoucherCodes.add(voucher.code);
              this.uniqueVouchers.push(voucher);
            }
          }

          for (const lq of labelConditions) {
            const labelSlug = lq?.labels;
            if (!labelSlug) continue;

            addToMap(labelSlug, voucher);

            if (selectedLabels.has(labelSlug) && !seenVoucherCodes.has(voucher.code)) {
              seenVoucherCodes.add(voucher.code);
              this.uniqueVouchers.push(voucher);
            }
          }

          for (const label of labelCondition) {
            const labelSlug = label?.trim().toLowerCase();
            if (!labelSlug) continue;

            addToMap(labelSlug, voucher);

            if (selectedLabels.has(labelSlug) && !seenVoucherCodes.has(voucher.code)) {
              seenVoucherCodes.add(voucher.code);
              this.uniqueVouchers.push(voucher);
            }
          }
        }
        const gttUnlimited = vouchers.find(v => v.code === 'GTT-Unlimited');
        if (gttUnlimited) {
          for (const item of items) {
            const sku = item.SKU;
            const labels = item.labels ?? [];

            if (sku) {
              addToMap(sku, gttUnlimited);
            }

            for (const label of labels) {
              if (label?.slug) {
                addToMap(label.slug, gttUnlimited);
              }
            }
          }

          for (const item of items) {
            if (!item.isSelected) continue;

            const sku = item.SKU;
            const labels = item.labels ?? [];

            if ((sku && selectedSkus.has(sku)) || labels.some(label => selectedLabels.has(label?.slug))) {
              if (!seenVoucherCodes.has(gttUnlimited.code)) {
                seenVoucherCodes.add(gttUnlimited.code);
                this.uniqueVouchers.push(gttUnlimited);
              }
              break;
            }
          }
        }
      },
      error: (err) => {
        console.error('Failed to fetch vouchers from cart:', err);
      }
    });
  }


  loadApplicableVouchers() {
    this.voucherService.getApplicableVouchers().subscribe({
      next: (res: Voucher[]) => {
        const applicable = (res ?? []).filter(v => v.isApplicable);
        this.applicableVoucherCodes = new Set(applicable.map(v => v.code));

        if (this.uniqueVouchers.length) {
          this.uniqueVouchers.sort((a, b) => {
            const aApplicable = this.isVoucherApplicable(a.code);
            const bApplicable = this.isVoucherApplicable(b.code);
            return (aApplicable === bApplicable) ? 0 : (aApplicable ? -1 : 1);
          });
        }
      },
      error: (err) => console.error(err)
    });
  }

  // useWalletCoin() {
  //   this.usingWalletCoin = !this.usingWalletCoin;

  //   if (this.usingWalletCoin) {
  //     if (this.userWallet) {
  //       this.usingCoinAmount = this.userWallet.balance;
  //     }
  //   }
  //   else {
  //     this.usingCoinAmount = 0;
  //   }

  //   const body = {
  //     amount: this.usingCoinAmount,
  //   }

  //   this.isUpdating = true;
  //   this.orderService.applyCoin(body).subscribe({
  //     next: (res: any) => {
  //       if (res) {
  //         this.cart = res;
  //         this.usingCoinAmount = this.cart.appliedCoin ?? 0;
  //         this.commonService.setCart(this.cart);
  //       }
  //     },
  //     error: (error: any) => {
  //       this.toastService.warning(error.error.message, '', {
  //         positionClass: 'toast-top-right',
  //       });
  //       this.isUpdating = false;
  //     },
  //     complete: () => {
  //       this.isUpdating = false;
  //     }
  //   });
  // }

  isVoucherApplicable(code: string): boolean {
    return this.applicableVoucherCodes.has(code);
  }

  calculateRoundedPercentageDiscount(voucher: Voucher): number {
    const baseAmount = (this.cart?.sumTotalPrice ?? 0) - (this.cart?.sumPriceSavingAmount ?? 0);
    let discount = (baseAmount * (voucher?.discountValue ?? 0)) / 100;
    discount = this.roundToNearest100(discount);

    if (voucher.maximumAmount && discount > voucher.maximumAmount) {
      return voucher.maximumAmount;
    }

    return discount;
  }
  roundToNearest100(amount: number): number {
    return Math.round(amount / 100) * 100;
  }

  trackBySKU(index: number, item: any): string {
    return item.SKU;
  }

  isVoucherApplied(code: string): boolean | undefined {
    return this.cart.appliedVouchers?.some(v => v.code === code);
  }

  hasTag(item: any, tagSlug: string): boolean {
    return item.labels?.some((l: any) => l.slug === tagSlug);
  }

  tagCount(item: any): number {
    let count = 0;
    if (this.hasTag(item, 'san-pham-doc-quyen')) count++;
    if (this.isPromotionalProduct(item)) count++;
    return count;
  }

  isPromotionalProduct(item: any): boolean {
    if (!item || !this.vouchers?.length) return false;
    const productLabelSlugs = item.labels?.map((l: any) => l.slug) ?? [];
    const productSku = String(item?.sku ?? '');
    const categoryIds = item.categories?.map((c: any) => c.categoryId) ?? [];

    for (const voucher of this.vouchers) {
      const condition = voucher.voucherCondition;
      if (!condition) continue;

      const labelQtyConditions = condition.applicableLabelQuantity ?? [];
      for (const cond of labelQtyConditions) {
        if (!cond?.labels?.length) continue;
        const condLabels = Array.isArray(cond.labels) ? cond.labels : [cond.labels];
        if (condLabels.some((slug: string) => productLabelSlugs.includes(slug))) {
          return true;
        }
      }

      const applicableLabels = condition.applicableLabels ?? [];
      if (applicableLabels.some((slug: string) => productLabelSlugs.includes(slug))) {
        return true;
      }

      const productQtyConditions = condition.productQuantityConditions ?? [];
      if (
        productQtyConditions.some(
          (cond: any) => String(cond?.sku ?? '') === productSku)
      ) {
        return true;
      }

      const applicableCategoryIds = condition.applicableCategoryIds ?? [];
      if (applicableCategoryIds.some((cid: string) => categoryIds.includes(cid))) {
        return true;
      }
      const categoryQtyConditions = condition.applicableCategoryQuantity ?? [];
      if (categoryQtyConditions.some((cond: any) => categoryIds.includes(cond.categoryId))) {
        return true;
      }
    }
    return false;
  }

  getPromotionalLabelSlug(item: any): string | null {
    if (!item || !this.vouchers?.length) return null;

    const productLabelSlugs = (item.labels ?? [])
      .map((l: any) => l.slug)
      .filter((slug: any): slug is string => typeof slug === 'string');

    for (const voucher of this.vouchers) {
      const condition = voucher.voucherCondition;
      if (!condition) continue;

      const labelQtyConditions = condition.applicableLabelQuantity ?? [];
      for (const cond of labelQtyConditions) {
        const condLabels = Array.isArray(cond?.labels) ? cond.labels : [cond?.labels];
        const matched = condLabels.find((slug: string) => productLabelSlugs.includes(slug));
        if (matched) return matched;
      }

      const applicableLabels = condition.applicableLabels ?? [];
      const matched = applicableLabels.find((slug: string) => productLabelSlugs.includes(slug));
      if (matched) return matched;
    }

    return null;
  }

  getFreeShip(selectedAddress: any) {

    if (!selectedAddress || !selectedAddress.provinceV2 || !selectedAddress.provinceV2.code) {
      this.freeShipMessage = '';
      this.shipValue = undefined;
      return;
    }

    this.cartService.caculateFreeShip(selectedAddress).subscribe({
      next: (res: FreeShipResponseModel) => {
        this.freeShipMessage = res?.messenge ?? '';
        this.shipValue = res?.value ?? 0;
      },
      error: (err) => {
        console.error('Caculate free ship error:', err);
        this.freeShipMessage = '';
        this.shipValue = undefined;
      }
    });
  }

  checkStatusShipping(selectedAddress: any) {

    if (!selectedAddress || !selectedAddress.provinceV2 || !selectedAddress.provinceV2.code) {
      this.shippingOptions = [];
      this.selectedShippingOption = null;
      return;
    }

    this.cartService.checkStatusShipping(selectedAddress)
      .subscribe(options => {
        this.shippingOptions = options ?? [];
        if (!this.shippingOptions.length) {
          this.resetShippingOption();
        }
      });
  }

  onSelectShipping(option: DeliveryTimeResponseModel) {
    this.selectedShippingOption = option;

    if (!this.selectedTransportMethod) return;

    this.selectedTransportMethod.paymentMethod = [...option.paymentMethod];

    if (!this.selectedTransportMethod.paymentMethod
      .some(p => p.code === this.selectedPaymentMethod?.code)) {

      this.selectedPaymentMethod =
        this.selectedTransportMethod.paymentMethod[0] ?? null;
    }
  }

  resetShippingOption() {
    this.selectedShippingOption = null;

    if (this.selectedTransportMethod) {
      this.selectedTransportMethod.paymentMethod = [...this.originalPaymentTerms];
    }
  }

  onClickPromoLabel(item: any): void {
    const slug = this.getPromotionalLabelSlug(item);
    if (slug) {
      this.queryStringBuilder(slug);
    }
  }

  checkAllGift() {
    this.isAllGiftItemsSelected = !this.isAllGiftItemsSelected;
    $('.chk-gift').prop('checked', $('.chk-gift-all').prop('checked'));
    this.selected = $('.chk-gift:checked').length;
  }

  deleteSelectedGifts() {
    if (!this.cart.giftItems.some(gift => gift.isSelected)) {
      this.toastService.error('Xin vui lòng chọn quà!', '', {
        positionClass: 'toast-top-right',
      });
      return;
    }

    for (let gift of this.cart.giftItems) {
      if (gift.isSelected) {
        this.removeGift(gift);
      }
    }
  }

  selectGift(gift: Gift) {
    gift.isSelected = !gift.isSelected;
  }

  removeGift(gift: Gift) {
    let body: any = {
      giftId: gift.giftId,
      quantity: 0,
      recordId: gift.recordId
    }
    this.giftService.updateGiftCart(body).subscribe({
      next: (res: any) => {
        if (res) {
          this.cartService.refreshCart();
          this.toastService.success(res.message, '', {
            positionClass: 'toast-top-right',
          });
        }
      },
      error: (error) => {
        console.log(error);
        this.cartService.refreshCart();
        this.toastService.error('Lỗi cập nhật giỏ hàng!', '', {
          positionClass: 'toast-top-right',
        });
      },
    });
  }

  gotoGiftList() {
    this.router.navigate(['/gift-list']);
  }

  confirmAddress(value?: any) {
    if (value != null) {
      this.cart.needReviewAddress = value;
      this.confirmCheckout(true);
    }
  }


  checkInvoiceAddressConfirmed() {
    this.addressService.checkInvoiceAddressReviewed().subscribe({
      next: (res: boolean) => {
        this.invoiceAddressHasReviewed = res;
      },
      error: (err) => console.error('Check invoice address reviewed error:', err)
    });
  }

  gotoBlog() {
    this.commonService.gotoLink();
  }

  getChangedCartItemsProducts() {
    this.cartService.getChangedCartItemsProducts().subscribe({
      next: (res) => {
        if (!res.isSuccess) return;

        this.isPriceChanged = res.data.isPriceChanged;
        this.priceChangedItems = res.data.changedProducts;

        if (!this.priceChangedItems.length) {
          this.showPriceChangeDetail = false;
        }
      },
      error: (err) => console.error('Get changed cart items error:', err)
    });
  }

  getAbsPrice(value: number): number {
    return Math.abs(value);
  }

  goToProduct(slug: string) {
    this.router.navigate(['/product', slug]);
  }

  openPriceModal() {
    this.modal.open();
  }

  onAcceptChangePrice() {
    console.log('User đồng ý giá mới → cho đi checkout');
    // this.checkout();
  }

  onCloseModal() {
    console.log('User đóng modal');
  }

  togglePriceDetail() {
    this.showPriceChangeDetail = !this.showPriceChangeDetail;
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  toggleVoucherDetail(voucher: any) {
    const selected = this.vouchers.find((item: Voucher)=> item.code === voucher.voucherCode);
    if (selected) {
      this.selectedVoucher = selected;
      this.safeTimeout(() => {
        this.detailModal.openModal();
      }, 0)
    }
  }

  applySuggestedVoucher(voucher: any) {
    const selected = this.vouchers.find((item: Voucher)=> item.code === voucher.voucherCode);
    if (selected) {
      this.applyVoucher(selected.code, selected.unitsUsed);
    }
  }

  onViewAlternatives(cartItem: any) {
    this.router.navigateByUrl(`/product/alternatives/${cartItem.slug}`);
  }

  checkTransportHasPayment() {
    this.dumpDataPayment.forEach(payment => {
    payment.disable =
      !this.selectedTransportMethod?.paymentMethod?.some(
        pm => pm.code === payment.code
      );
    })
  }

  getIconPayment (paymentCode: string) {
    return this.dumpDataPayment.find(item => item.code === paymentCode)?.icon || null
  }

  getIconActivePayment (paymentCode: string) {
    return this.dumpDataPayment.find(item => item.code === paymentCode)?.iconActive || null
  }

  openCartHistoryModal() {
    if (this.cartHistoryModal) {
      this.cartHistoryModal.openModal();
    }
  }

  onCartRestored() {
    this.cartService.refreshCart();
    this.toastService.success('Đã khôi phục sản phẩm vào giỏ hàng!', '', {
      positionClass: 'toast-top-right',
    });
  }

  closeModalVoucher() {
    this.modalVoucherOpen = false;
  }

  getVoucherOnItems() {
    this.cartService.getCartItemsWithVoucher().subscribe({
      next: (res: any) => {
        if (res && res.length) {
          const voucherMap = res.reduce((acc: Record<string, potentialVoucher[]>, voucher: potentialVoucher) => {
            const sku = voucher.sku;
            if (!acc[sku]) {
              acc[sku] = [];
            }
            acc[sku].push(voucher);
            return acc;
          }, {} as Record<string, potentialVoucher[]>);
          this.voucherMap = voucherMap;
          this.cart.items = this.cart.items.map((item: CartItem) => {
            return {
              ...item,
              potentialVouchers: voucherMap[item.SKU] || []
            };
          });
        }
      },
      error: (err) => console.error('Get cart items with voucher error:', err)
    });
  }

  get isInvoiceForced(): boolean {
    return this.isShipmentInOrderEnabled || false;
  }

  get invoiceTooltip(): string | null {
    return this.isShipmentInOrderEnabled
      ? 'Hóa đơn giấy sẽ luôn được xuất khi đặt hàng'
      : null;
  }

  onToggleSaveOrderTemplate(): void {
    if (this.isSaveOrderTemplate && (!this.orderTemplateName || !this.orderTemplateName.trim())) {
      this.orderTemplateName = 'Đơn hàng thường xuyên mới';
    }
  }
}


